/**
 * @param {unknown} date
 * @returns boolean
 */
export function isValidDate(date) {
  var d = new Date(date);
  if (d == "Invalid Date") return false;

  if (isNaN(d.getTime())) return false;

  return true;
}
